import React, { Component } from 'react';
import NormalLink from './NormalLink';

export class DropDown extends Component {
  render() {
    return (
      <div style={{ marginBottom: '4px' }}>
        <div className="vm-sidebar-section-label">{this.props.name}</div>
        {this.props.list.map((item) => (
          <NormalLink
            key={item.url}
            name={item.name}
            url={item.url}
            icon={this.props.icon}
            poptext={this.props.text}
            activeUrl={this.props.activeUrl}
            toggleSideBar={this.props.toggleSideBar}
          />
        ))}
      </div>
    );
  }
}

export default DropDown;